import React, { useState } from 'react';
import PropTypes from 'prop-types';

import useSearchStore from '../../_global/js/SearchStore';
import toKebabCase from '../../_global/js/stringToKebab';

function AppliedFacetTag({ tagLabel, facetValue, facetParamName }) {
    const [inputIsDisabled, setInputIsDisabled] = useState(false);

    const selectedFacetOptions = useSearchStore((state) =>
        state.getSearchFacetSelectionsByKey(facetParamName)
    );
    const setSearchFacetSelectionsByKey = useSearchStore(
        (state) => state.setSearchFacetSelectionsByKey
    );

    /**
     * Respond to changes to the "applied filter" inputs
     *
     * @param {Change Event} evt Event that triggered the change
     *
     * @returns void
     */
    const onTagClick = (evt) => {
        const checkboxValue = evt.target.getAttribute('name');
        const currentSelectedOptions = [...selectedFacetOptions];

        // Disable the button to prevent multiple clicks
        setInputIsDisabled(true);

        // Remove this from the list of selected facets
        const valueIndex = currentSelectedOptions.indexOf(checkboxValue);

        if (valueIndex !== -1) {
            currentSelectedOptions.splice(valueIndex, 1);
            setSearchFacetSelectionsByKey(
                facetParamName,
                currentSelectedOptions
            );
        }
    };

    return (
        <>
            <label
                className="facet-group__checkbox-label"
                htmlFor={toKebabCase(facetValue)}
            >
                <input
                    className="facet-group__checkbox"
                    disabled={inputIsDisabled}
                    id={toKebabCase(facetValue)}
                    name={facetValue}
                    onChange={onTagClick}
                    type="checkbox"
                />
                <span className="pill input">
                    {tagLabel}{' '}
                    <span className="facet-group__results-remove">
                        <svg className="svg-icon">
                            <use href="#rse-close" />
                        </svg>
                    </span>
                </span>
            </label>
        </>
    );
}

export default React.memo(AppliedFacetTag);

AppliedFacetTag.propTypes = {
    tagLabel: PropTypes.string,
    facetValue: PropTypes.string,
    facetParamName: PropTypes.string,
};

AppliedFacetTag.defaultProps = {
    tagLabel: 'Early Childhood',
    facetValue: '',
    facetParamName: '',
};
